import { useContext } from 'react';

import { useHubConnection, useTaxReturnRuntimeValues } from '@dec/shared';
import { type HubConnection } from '@microsoft/signalr';

import { GlobalTaxReturnContext } from '../GlobalTaxReturnContext';
import { type GlobalTaxReturnValues, type SocketConnection } from '../models/types';

import { TaxReturnNotificationsConnection } from './hubConnection';

export function useCreateConnection(
  createConnection: () => HubConnection,
  readOnly = false
): SocketConnection {
  return useHubConnection(createConnection, !readOnly);
}

export const useGetFormConnection = (): HubConnection => {
  const { connection } = useContext(TaxReturnNotificationsConnection);
  return connection as HubConnection;
};

export const useGetGlobalTaxReturnValues = (): GlobalTaxReturnValues => {
  const values = useTaxReturnRuntimeValues(GlobalTaxReturnContext);
  return values;
};
